import { useNavigate } from "@/router"
import { useState, useEffect } from "react"
import { useAuth } from "@/services/userService"
import { useRefreshToken } from "@/services/apiService"
import { axiosErrorToStringError } from "@/utils/axiosErrorToStringError"
import { isAxiosError } from "axios"
import { BarLoader } from "react-spinners";

// eslint-disable-next-line react/prop-types
export const RouteGuard = ({children}) => {

    const { auth, setAccessToken, setUser } = useAuth();
    const [error, setError] = useState(null);

    const refresh = useRefreshToken()
    const navigate = useNavigate()


    useEffect(() => {

        const afterRefreshHandler = async () => {
            try {
                const result = await refresh();
                // console.debug('RouteGuard::afterRefreshHandler::at', at)
                // await new Promise(resolve => setTimeout(resolve, 1000));
                setAccessToken(result)
            } catch (error) {
                console.error('RouteGuard::afterRefreshHandler::error', error)
                if (error?.response?.status === 401) {
                    if (setUser)
                        setUser(null)
                    navigate('/login', {replace: true})
                } else if (isAxiosError(error)) {
                    setError(axiosErrorToStringError(error))
                } else {
                    setError(error?.message || "Erreur inconnue")
                }
            }
        }

        if(!auth.isIdpLoading && auth.isLoading && !auth.isAuthenticated && !auth.fromIdp) {
            afterRefreshHandler();
        }

    }, [auth.isIdpLoading, auth.isAuthenticated, auth.fromIdp, auth.isLoading]) //eslint-disable-line react-hooks/exhaustive-deps

    return (
        !error 
            ? auth.isFullyLoaded 
                ? children 
                : <div className="w-full flex justify-center pt-10"><BarLoader color="#00BFFF" size={100} /></div>
            : <p>{error}</p>
    )
    
}